import { gql, TypedDocumentNode } from '@apollo/client'
import type { SessionSagaUserQuery } from './__generated__/SessionSagaUserQuery'

export const sessionSagaUserQuery: TypedDocumentNode<SessionSagaUserQuery> = gql`
  query SessionSagaUserQuery {
    user {
      id
      company {
        id
        logo
      }
    }
  }
`
